import OrderStatusLookup from 'components/RichProfile/MyAccount/OrderStatusLookup/OrderStatusLookup';
import { withOrderStatusLookupProps } from 'viewModel/richProfile/myAccount/orderStatusLookup/withOrderStatusLookupProps';

export default withOrderStatusLookupProps(OrderStatusLookup);
